import { render, staticRenderFns } from "./faq.vue?vue&type=template&id=983b40dc&scoped=true"
import script from "./faq.vue?vue&type=script&setup=true&lang=js"
export * from "./faq.vue?vue&type=script&setup=true&lang=js"
import style0 from "./faq.vue?vue&type=style&index=0&id=983b40dc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.16_babel-core@7.0.0-bridge.0_@babel+core@7.27._f767d633ff263e3cf51932694db5e4d0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983b40dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/front/game-platform-web/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('983b40dc')) {
      api.createRecord('983b40dc', component.options)
    } else {
      api.reload('983b40dc', component.options)
    }
    module.hot.accept("./faq.vue?vue&type=template&id=983b40dc&scoped=true", function () {
      api.rerender('983b40dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/admin/site/faq.vue"
export default component.exports